// extracted by mini-css-extract-plugin
export default {"chipContainer":"InstallationStatusLabel_chipContainer__jYASp","retryIcon":"InstallationStatusLabel_retryIcon__uvlRl"};